import React from 'react'
import { Container, Row } from 'reactstrap'
import BlogSidebar from '../Common/BlogSidebar'
import BlogContent from './BlogContent'

export default function BlogDetailsContainer() {
    return (
        <>
            <Container className="blog-detail-page" fluid>
                <Row>
                    <BlogContent />
                    <BlogSidebar />
                </Row>
            </Container>
        </>
    )
}